<template>
  <div class="physical-data">
    <p class="physical-data__title">
      Физические данные
    </p>
    <DigitalBlock
      v-model:first="searchStore.searchOptions.age.from"
      v-model:second="searchStore.searchOptions.age.to"
      :title="'Возраст'"
      orText="-"
      :firstPlaceholder="'От 18 лет'"
      :secondPlaceholder="'До 35 лет'"
    />
    <DigitalBlock
      v-model:first="searchStore.searchOptions.bustSize.from"
      v-model:second="searchStore.searchOptions.bustSize.to"
      :title="'Размер груди'"
      orText="-"
      :firstPlaceholder="'От 1'"
      :secondPlaceholder="'До 12'"
    />
    <DigitalBlock
      v-model:first="searchStore.searchOptions.height.from"
      v-model:second="searchStore.searchOptions.height.to"
      :title="'Рост'"
      orText="-"
      :firstPlaceholder="'От 150 см'"
      :secondPlaceholder="'До 210 см'"
    />
    <DigitalBlock
      v-model:first="searchStore.searchOptions.weight.from"
      v-model:second="searchStore.searchOptions.weight.to"
      :title="'Вес'"
      orText="-"
      :firstPlaceholder="'От 20 кг'"
      :secondPlaceholder="'До 190 кг'"
    />
  </div>
</template>

<script setup lang="ts">
import DigitalBlock from "@/searchSection/components/SearchPanel/DigitalBlock.vue";
import { useSearchStore } from "@/searchSection/store/searchStore";

const searchStore = useSearchStore()
</script>

<style scoped lang="scss">
.physical-data {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 12px;
  row-gap: 20px;
  margin-top: 20px;

  @media screen and (max-width: 580px) {
    grid-template-columns: 1fr;
  }

  &__title {
    grid-column: 1/3;

    @media screen and (max-width: 580px) {
      grid-column: initial;
    }
  }
}
</style>